export default "__VITE_ASSET__ryy6kdlG__"